import { createSvgIcon } from '@mui/material';

const SectionIcon = (props) => {
  const IconCmp = createSvgIcon(
    <path
      d="M13.5833 12.7389H4.41667M13.5833 9.4056H4.41667M1.5 6.07227H16.5M5.5 1.07227H12.5C13.9001 1.07227 14.6002 1.07227 15.135 1.34475C15.6054 1.58443 15.9878 1.96688 16.2275 2.43729C16.5 2.97207 16.5 3.67213 16.5 5.07227V12.0723C16.5 13.4724 16.5 14.1725 16.2275 14.7072C15.9878 15.1776 15.6054 15.5601 15.135 15.7998C14.6002 16.0723 13.9001 16.0723 12.5 16.0723H5.5C4.09987 16.0723 3.3998 16.0723 2.86502 15.7998C2.39462 15.5601 2.01217 15.1776 1.77248 14.7072C1.5 14.1725 1.5 13.4724 1.5 12.0723V5.07227C1.5 3.67213 1.5 2.97207 1.77248 2.43729C2.01217 1.96688 2.39462 1.58443 2.86502 1.34475C3.3998 1.07227 4.09987 1.07227 5.5 1.07227Z"
      stroke="#6868FE"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />,
    'SectionIcon',
  );
  return (
    <IconCmp
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      style={{ fill: 'none' }}
      {...props}
    />
  );
};
export default SectionIcon;
